import React, { createContext, useState, useEffect } from 'react';
import { useLocalStorageState } from '../hooks';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const UIContext = /*#__PURE__*/createContext({
  appBarStart: () => null,
  renderAppBarStart: () => {},
  appBarEnd: () => null,
  renderAppBarEnd: () => {},
  darkMode: false,
  setDarkMode: () => {},
  navCollapsed: false,
  setNavCollapsed: () => {},
  pageTitle: '',
  setPageTitle: () => {},
  breadcrumbs: [],
  setBreadcrumbs: () => {}
});
export function UIProvider({
  children,
  value: overrideValue
}) {
  const [darkMode, setDarkMode] = useLocalStorageState('darkMode', window && window.matchMedia('(prefers-color-scheme: dark)').matches);
  const [navCollapsed, setNavCollapsed] = useLocalStorageState('navCollapsed', false);
  const [pageTitle, setPageTitle] = useState('');
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [appBarStart, setAppBarStart] = useState(() => () => null);
  const [appBarEnd, setAppBarEnd] = useState(() => () => null);

  // Allow external control of darkMode (e.g., from Storybook)
  const effectiveDarkMode = (overrideValue === null || overrideValue === void 0 ? void 0 : overrideValue.darkMode) !== undefined ? overrideValue.darkMode : darkMode;

  // Sync external darkMode changes to localStorage
  useEffect(() => {
    if ((overrideValue === null || overrideValue === void 0 ? void 0 : overrideValue.darkMode) !== undefined && overrideValue.darkMode !== darkMode) {
      setDarkMode(overrideValue.darkMode);
    }
  }, [overrideValue === null || overrideValue === void 0 ? void 0 : overrideValue.darkMode, darkMode, setDarkMode]);
  function renderAppBarStart(fn) {
    setAppBarStart(() => fn);
  }
  function renderAppBarEnd(fn) {
    setAppBarEnd(() => fn);
  }
  return ___EmotionJSX(UIContext.Provider, {
    value: {
      appBarStart,
      renderAppBarStart,
      appBarEnd,
      renderAppBarEnd,
      darkMode: effectiveDarkMode,
      setDarkMode,
      navCollapsed,
      setNavCollapsed,
      pageTitle,
      setPageTitle,
      breadcrumbs,
      setBreadcrumbs
    }
  }, children);
}